<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup lang="ts">
// App.vue - Main application component
</script>

<style scoped>
#app {
  height: 100vh;
  width: 100vw;
}
</style>
